export default __webpack_public_path__ + "static/media/Gulmarg1.9496280c.jpg";